/* ManageDeviceViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ManageDeviceViewRenderer");
const PagingDeviceFeed = require("./PagingDeviceFeed");
const _ = require("lodash");

class ManageDeviceViewComponent extends EventEmitter {
    constructor(queryDetails) {
        super();
        this._queryDetails = queryDetails;
        this._gameEditor = this._queryDetails.getGameEditor();
        this._modalUserFeedback = this._queryDetails._modalUserFeedback;
        this._pageSize = 100;
        this._gridKey = "manage_device_ad_hoc_editor";
        this._logger = this._queryDetails._logger;
        // this._plan = this._queryDetails.getPlan();
        this._isDirty = false;
        this._selectedDevices = _.cloneDeep(this._queryDetails._selectedDevices);
        this._selectedIDs = undefined;
        this._userGridData = undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    shutdown() {
        return this.isDirtyChecked()
            .then(() => this._selectedDevicesPagingFeed.shutdown())
            .then(() => this._availableDevicesPagingFeed.shutdown())
            .then(() => {
                this.emit("Shutdown");
                this._unregisterListeners();
                this._availableDevicesPagingFeed = undefined;
                this._selectedDevicesPagingFeed = undefined;
                this._queryDetails = undefined;
                this._selectedIDs = undefined;
                this._userGridData = undefined;
                Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn("Error in shutdown", { err });
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get isDirty() {
        return this._isDirty;
    }

    set isDirty(newValue) {
        this._isDirty = newValue;
        return true;
    }
    get selectedIDs() {
        return this._selectedIDs;
    }

    set selectedIDs(newValue) {
        this._selectedIDs = newValue;
        return true;
    }

    get gameEditor() {
        return this._gameEditor;
    }

    // get getQueryDetailsView() {
    //     return this._plan;
    // }

    get availColumnConfig() {
        return {
            name: {
                label: "Name",
                entityColumn: "name",
                width: 150
            },
            description: {
                label: "Description",
                entityColumn: "description",
                width: 150
            },
            detectedSku: {
                label: "SKUs",
                entityColumn: "detectedSku",
                width: 100
            },
            siteCodeName: {
                label: "Site Code Name",
                entityColumn: "siteCodeName",
                width: 120
            }
        };
    }

    get selColumnConfig() {
        return {
            name: {
                label: "Name",
                entityColumn: "name",
                width: 150
            },
            description: {
                label: "Description",
                entityColumn: "description",
                width: 150
            },
            detectedSku: {
                label: "SKUs",
                entityColumn: "detectedSku",
                width: 100
            },
            siteCodeName: {
                label: "Site Code Name",
                entityColumn: "siteCodeName",
                width: 120
            }
        };
    }

    get availableTargetsPagingFeed() {
        return this._availableDevicesPagingFeed;
    }
    get selectedTargetsPagingFeed() {
        return this._selectedDevicesPagingFeed;
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    wasFeedPreviouslyInitialized() {
        return this._availableDevicesPagingFeed.wasPreviouslyInitialized();
    }

    whenFeedReady() {
        return this._queryDetails._storageFactory
            .whenStorageIsReady()
            .then(() => {
                this._userGridData = this._queryDetails._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    `${this._gridKey}_available`
                );
            })
            .then(() => {
                this._createAvailPagingFeed();
                this._createSelPagingFeed();
                return Promise.resolve();
            })
            .then(() => {
                this._selectedDevices = _.cloneDeep(this._queryDetails._selectedDevices);
                return Promise.all([
                    this._getWorkTargetIds(),
                    this._availableDevicesPagingFeed.whenFeedReady(),
                    this._selectedDevicesPagingFeed.whenFeedReady()
                ]);
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _getWorkTargetIds() {
        this._selectedIDs = this._queryDetails._selectedDevices;
    }
    _createAvailPagingFeed() {
        if (this._availableDevicesPagingFeed) {
            this._availableDevicesPagingFeed.shutdown();
        }
        this._availableDevicesPagingFeed = this._createPagingFeed(this.availColumnConfig, "$nin", `${this._gridKey}_available`, true);
    }

    _createSelPagingFeed() {
        if (this._selectedDevicesPagingFeed) {
            this._selectedDevicesPagingFeed.shutdown();
        }
        this._selectedDevicesPagingFeed = this._createPagingFeed(this.selColumnConfig, "$in", `${this._gridKey}_selected`, false);
    }

    _createPagingFeed(columnConfig, mongoIdOperator, feedKey, isFilter) {
        return new PagingDeviceFeed({
            activeOrgId: this._gameEditor.activeOrgId,
            entityDef: this._queryDetails.getDeviceEntity(),
            entityType: "Device",
            columnConfig: columnConfig,
            pageSize: this._pageSize,
            mongoIdOperator: mongoIdOperator,
            sort: { name: 1 },
            filter: isFilter ? _.get(this._userGridData.getBasicSearchData(), "filterQuery", {}) : {},
            feedKey
        });
    }
    _saveDevice() {
        return Promise.resolve()
            .then(() => {
                this._queryDetails._selectedDevices = this._selectedDevices;
                this._queryDetails._adHocRun = false;
                if (!this._queryDetails.isDirty()) {
                    this._gameEditor.getTabCmpnt().setDirty(false);
                }
                this.isDirty = false;

                this.emit("DeviceCountUpdated", this._selectedDevices.length);

                return Promise.resolve();
            })
            .then(() => {
                return this._queryDetails.getAllResultEntities();
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "ManageDeviceViewComponent.saveDevice() error.");
                this._modalUserFeedback.displayError(err);
                return Promise.reject();
            });
    }
    _removeDevices(ids) {
        this._selectedDevices = _.without(this._selectedDevices, ...ids);

        if (this._queryDetails._selectedDevices !== this._selectedDevices) {
            this._gameEditor.getTabCmpnt().setDirty(true);
            this.isDirty = true;
        } else {
            if (!this._queryDetails.isDirty()) {
                this._gameEditor.getTabCmpnt().setDirty(false);
            }
            this.isDirty = false;
        }
    }
    _addDevices(ids) {
        this._selectedDevices = _.concat(this._selectedDevices, ids);

        if (this._queryDetails._selectedDevices !== this._selectedDevices) {
            this._gameEditor.getTabCmpnt().setDirty(true);
            this.isDirty = true;
        } else {
            if (!this._queryDetails.isDirty()) {
                this._gameEditor.getTabCmpnt().setDirty(false);
            }
            this.isDirty = false;
        }
    }
    isDirtyChecked() {
        if (this.isDirty) {
            return this._modalUserFeedback
                .displayConfirmation("Would you like to Save or Discard your changes?", {
                    title: "Unsaved Changes",
                    confirmDetails: {
                        text: "Save",
                        type: "additive"
                    },
                    rejectDetails: {
                        text: "Discard",
                        type: "text"
                    }
                })
                .then(() => {
                    return this._saveDevice().then(() => undefined); // it will not close the tab if it will have something in result
                })
                .catch((err) => {
                    if (err.userRejected) {
                        return Promise.resolve()
                            .then(() => this._modalUserFeedback.hideDisplayed())
                            .then(() => {
                                if (!this._queryDetails.isDirty()) {
                                    this._gameEditor.getTabCmpnt().setDirty(false);
                                }
                                return Promise.resolve();
                            });
                    }
                });
        } else {
            return Promise.resolve();
        }
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = ManageDeviceViewComponent;
